"use client";

import * as React from "react";

export default function TopbarSearch() {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef<HTMLDivElement | null>(null);
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  React.useEffect(() => {
    function onDocClick(e: MouseEvent) {
      const root = rootRef.current;
      if (!root) return;
      if (e.target instanceof Node && !root.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <div className="topbar-search" ref={rootRef}>
      <button
        className={`user-btn ${open ? "is-open" : ""}`}
        title="Suche"
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label="Suche oeffnen"
      >
        🔍
      </button>
      {open ? (
        <div className="topbar-search-pop">
          <input ref={inputRef} className="global-search topbar-search-input" placeholder="Suchen…" aria-label="Suchen" />
        </div>
      ) : null}
    </div>
  );
}

